import { PermissionsService } from '@b2b/common/services/permissions';
import angular, { IDirective } from 'angular';

PermissionsDirectiveFactory.$inject = ['PermissionsService'];

function PermissionsDirectiveFactory(permissionsService: PermissionsService) {
  return {
    restrict: 'A',
    link: ($scope, $element, $attrs) => {
      const mode = $scope.$eval($attrs.acmePermissionsMode) === 'some' ? 'some' : 'every';
      const parsedPermissions = $scope.$eval($attrs.acmePermissions) as string | string[];

      // Call through the service reference so `this` binds to PermissionsService.
      // Destructuring `const checkPermissions = permissionsService[mode]` worked
      // with the old AngularJS service (closure-based `self` capture) but breaks
      // the Angular 18 class downgrade where `every`/`some` rely on `this`.
      if (permissionsService[mode](parsedPermissions)) {
        return;
      }

      $element.remove();
    },
  } satisfies IDirective;
}

export const PermissionsDirectiveModule = angular
  .module('acme.common.directives.permissions', ['acme.common.service.permissions'])
  .directive('acmePermissions', PermissionsDirectiveFactory).name;
